<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isSysAdmin()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluser_id">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>Profile | O2Suite</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluser_id -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <!-- main row for all icons  -->
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-4 flex">
                        <div class="card card-secondary card-outline">
                            <div class="card-body box-profile">
                                <div class="text-center">
                                    <img
                                        class="profile-user-img img-circle profile-image"
                                        style="
                                            border-radius: 50% !important;
                                            height: 7rem !important;
                                            width: 7rem !important;
                                        "
                                        :src="user_info.profile_pic"
                                        alt="User profile picture"
                                    />
                                </div>
                                <h3 class="profile-username text-center">
                                    {{ form.name }}
                                </h3>
                                <p class="text-muted text-center">
                                    {{ user_info.user_type }}
                                </p>
                                <!--            <ul class="list-group list-group-unbordered mb-3">-->
                                <!--                <li class="list-group-item">-->
                                <!--                    <b>Followers</b> <a class="float-right">1,322</a>-->
                                <!--                </li>-->
                                <!--                <li class="list-group-item">-->
                                <!--                    <b>Following</b> <a class="float-right">543</a>-->
                                <!--                </li>-->
                                <!--                <li class="list-group-item">-->
                                <!--                    <b>Friends</b> <a class="float-right">13,287</a>-->
                                <!--                </li>-->
                                <!--            </ul>-->
                                <a
                                    @click="updateProfileImageModal"
                                    v-if="
                                        lead_profile_id != '' &&
                                        lead_profile_id != null
                                    "
                                    class="btn btn-secondary btn-block"
                                    ><b>Change Image</b></a
                                >
                                <small
                                    >Image will change once verified by admin.
                                    Retry only if image hasn't appeared after 6
                                    hours.</small
                                >
                            </div>
                        </div>
                        <div class="card card-secondary card-outline">
                            <div class="card-header">
                                <h5>Profile</h5>
                            </div>
                            <div class="card-body overflow-auto">
                                <form @submit.prevent="updateCustomer">
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.name ? 'has-error' : '',
                                        ]"
                                        v-if="
                                            $gate.isSysAdmin() ||
                                            $gate.isHRAdmin() ||
                                            $gate.isMISAdmin() ||
                                            $gate.isSecondaryMISAdmin() ||
                                            $gate.isCCManager() ||
                                            lead_profile_id == null ||
                                            lead_profile_id == ''
                                        "
                                    >
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the customer name"
                                            v-model="form.name"
                                        />
                                        <span
                                            v-if="errors.name"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid name.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.name ? 'has-error' : '',
                                        ]"
                                        v-if="
                                            !$gate.isSysAdmin() &&
                                            !$gate.isHRAdmin() &&
                                            !$gate.isMISAdmin() &&
                                            !$gate.isSecondaryMISAdmin() &&
                                            !$gate.isCCManager() &&
                                            lead_profile_id != null &&
                                            lead_profile_id != ''
                                        "
                                    >
                                        <label>Name</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter the customer name"
                                            v-model="form.name"
                                            disabled
                                        />
                                        <span
                                            v-if="errors.name"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid name.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.gender ? 'has-error' : '',
                                        ]"
                                    >
                                        <label>Gender</label>
                                        <select
                                            class="form-control"
                                            placeholder="Select customer gender"
                                            v-model="form.gender"
                                        >
                                            <option value="M">Male</option>
                                            <option value="F">Female</option>
                                            <option value="O">Other</option>
                                        </select>
                                        <span
                                            v-if="errors.gender"
                                            :class="['badge bg-danger']"
                                            >Please choose a valid gender.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.dob ? 'has-error' : '',
                                        ]"
                                    >
                                        <label>DOB</label>
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="Enter date of birth"
                                            v-model="form.dob"
                                        />
                                        <span
                                            v-if="errors.dob"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid dob.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.blood_group
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <label>Blood Type</label>
                                        <select
                                            id="blood_group"
                                            placeholder="Pick blood type (Please ensure correctness)"
                                            class="form-control"
                                            v-model="form.blood_group"
                                        >
                                            <option value="A+">A+ve</option>
                                            <option value="A-">A-ve</option>
                                            <option value="B+">B+ve</option>
                                            <option value="B-">B-ve</option>
                                            <option value="O+">O+ve</option>
                                            <option value="O-">O-ve</option>
                                            <option value="AB+">AB+ve</option>
                                            <option value="AB-">AB-ve</option>
                                        </select>
                                        <span
                                            v-if="errors.blood_group"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid type.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.mobile ? 'has-error' : '',
                                        ]"
                                    >
                                        <label>Phone 1</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter phone 1"
                                            v-model="form.mobile"
                                        />
                                        <span
                                            v-if="errors.mobile"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid phone
                                            number.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.alt_mobile
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <label>Phone 2</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter phone 2"
                                            v-model="form.alt_mobile"
                                        />
                                        <span
                                            v-if="errors.alt_mobile"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid phone
                                            number.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.phone ? 'has-error' : '',
                                        ]"
                                    >
                                        <label>Phone 3</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter phone 3"
                                            v-model="form.phone"
                                        />
                                        <span
                                            v-if="errors.phone"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid phone
                                            number.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.alt_phone ? 'has-error' : '',
                                        ]"
                                    >
                                        <label>Phone 4</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter phone 4"
                                            v-model="form.alt_phone"
                                        />
                                        <span
                                            v-if="errors.alt_phone"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid phone
                                            number.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.email ? 'has-error' : '',
                                        ]"
                                    >
                                        <label>E-mail</label>
                                        <input
                                            type="email"
                                            class="form-control"
                                            placeholder="Enter email address"
                                            v-model="form.email"
                                        />
                                        <span
                                            v-if="errors.email"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid email.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.alt_email ? 'has-error' : '',
                                        ]"
                                    >
                                        <label>Alt E-mail</label>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Enter alternate email address"
                                            v-model="form.alt_email"
                                        />
                                        <span
                                            v-if="errors.alt_email"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid email.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.marital_status
                                                ? 'has-error'
                                                : '',
                                        ]"
                                    >
                                        <label>Marital Status:</label>
                                        <select
                                            id="marital_status"
                                            placeholder="Pick marital status"
                                            class="form-control"
                                            v-model="form.marital_status"
                                        >
                                            <option value="Single">
                                                Single
                                            </option>
                                            <option value="Married">
                                                Married
                                            </option>
                                        </select>
                                        <span
                                            v-if="errors.marital_status"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid status.</span
                                        >
                                    </div>
                                    <div
                                        :class="[
                                            'form-group',
                                            errors.wedding_anniversary
                                                ? 'has-error'
                                                : '',
                                        ]"
                                        v-if="form.marital_status == 'Married'"
                                    >
                                        <label>Wedding Anniversary:</label>
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="Enter date of marriage"
                                            v-model="form.wedding_anniversary"
                                        />
                                        <span
                                            v-if="errors.wedding_anniversary"
                                            :class="['badge bg-danger']"
                                            >Please enter a valid date.</span
                                        >
                                    </div>
                                    <!--						<div :class="['form-group', errors.membership_id ? 'has-error' : '']">-->
                                    <!--							<label>Membership ID</label>-->
                                    <!--							<input type="text" class="form-control" placeholder="Enter membership ID" v-model="form.membership_id">-->
                                    <!--							<span v-if="errors.membership_id" :class="['badge bg-danger']">Please enter a valid membership ID.</span>-->
                                    <!--						</div>-->
                                    <!--						<div :class="['form-group', errors.category ? 'has-error' : '']">-->
                                    <!--							<label>Category</label>-->
                                    <!--							<input type="text" class="form-control" placeholder="Enter the category" v-model="form.category">-->
                                    <!--							<span v-if="errors.category" :class="['badge bg-danger']">Please enter a valid category.</span>-->
                                    <!--						</div>-->
                                    <!--						<div :class="['form-group', errors.area ? 'has-error' : '']">-->
                                    <!--							<label>Area</label>-->
                                    <!--							<input type="text" class="form-control" placeholder="Enter the area" v-model="form.area">-->
                                    <!--							<span v-if="errors.area" :class="['badge bg-danger']">Please enter a valid area.</span>-->
                                    <!--						</div>-->
                                    <!--						<div :class="['form-group', errors.doa ? 'has-error' : '']">-->
                                    <!--							<label>DOA</label>-->
                                    <!--							<input type="text" class="form-control" placeholder="Enter DOA" v-model="form.doa">-->
                                    <!--							<span v-if="errors.doa" :class="['badge bg-danger']">Please enter a valid doa.</span>-->
                                    <!--						</div>-->
                                    <div class="form-group">
                                        <button
                                            class="btn btn-secondary"
                                            style="width: 100% !important"
                                            type="submit"
                                        >
                                            Submit Changes
                                        </button>
                                    </div>
                                </form>

                                <!-- content here -->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 flex">
                        <div class="card card-danger card-outline">
                            <div class="card-header">
                                <b>Addresses</b>
                                <button
                                    class="btn btn-danger float-right"
                                    v-if="
                                        lead_profile_id != '' &&
                                        lead_profile_id != null
                                    "
                                    @click="add"
                                >
                                    <i class="fa fa-plus"></i> Add Address
                                </button>
                            </div>
                            <div class="card-body overflow-auto">
                                <table
                                    class="table table-striped table-bordered table-hover"
                                >
                                    <thead>
                                        <tr>
                                            <th>Address</th>
                                            <th>City</th>
                                            <th>State</th>
                                            <th>Manage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="j in addresses" :key="j.id">
                                            <td>
                                                {{ j.addr_l1 }},
                                                {{ j.addr_l2 }}, {{ j.addr_l3 }}
                                            </td>
                                            <td>{{ j.city }}</td>
                                            <td>{{ j.state }}</td>
                                            <td>
                                                <p>
                                                    <button
                                                        class="btn btn-primary fa fa-edit"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        @click="change(j)"
                                                    ></button>
                                                </p>
                                                <p>
                                                    <button
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        v-if="
                                                            $gate.isSysAdmin() ||
                                                            $gate.isHRAdmin() ||
                                                            $gate.isMISAdmin() ||
                                                            $gate.isSecondaryMISAdmin()
                                                        "
                                                        class="btn btn-danger fa fa-trash"
                                                        @click="deleteA(j.id)"
                                                    ></button>
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div class="card card-secondary card-outline">
                            <div class="card-header">
                                <b>Educational Qualifications</b>
                                <button
                                    class="btn btn-primary float-right"
                                    v-if="
                                        lead_profile_id != '' &&
                                        lead_profile_id != null
                                    "
                                    @click="updateEducationalHistory"
                                >
                                    <i class="fa fa-plus"></i> Add Qualification
                                </button>
                            </div>
                            <div class="card-body overflow-auto">
                                <table
                                    class="table table-striped table-bordered table-hover"
                                >
                                    <thead>
                                        <tr>
                                            <th>Qualification</th>
                                            <th>
                                                Institution and Specialization
                                            </th>
                                            <th>DOJ</th>
                                            <th>YOP</th>
                                            <th
                                                v-if="
                                                    $gate.isSysAdmin() ||
                                                    $gate.isHRAdmin() ||
                                                    $gate.isMISAdmin() ||
                                                    $gate.isSecondaryMISAdmin()
                                                "
                                            >
                                                Verification
                                            </th>
                                            <th>Manage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="k in educational_history"
                                            :key="k.id"
                                        >
                                            <td>{{ k.qualification_type }}</td>
                                            <td>
                                                <p>{{ k.specialization }}</p>
                                                <p>{{ k.institution }}</p>
                                            </td>
                                            <td>
                                                {{ k.joining_date | smallDate }}
                                            </td>
                                            <td
                                                v-if="k.completion_date != null"
                                            >
                                                {{
                                                    k.completion_date
                                                        | smallDate
                                                }}
                                            </td>
                                            <td
                                                v-if="k.completion_date == null"
                                            >
                                                Ongoing
                                            </td>
                                            <td
                                                v-if="
                                                    $gate.isSysAdmin() ||
                                                    $gate.isHRAdmin() ||
                                                    $gate.isMISAdmin() ||
                                                    $gate.isSecondaryMISAdmin()
                                                "
                                            >
                                                <span
                                                    class="badge badge-success"
                                                    v-if="k.verified == true"
                                                    @click="
                                                        verifyEducationPrompt(k)
                                                    "
                                                    ><i
                                                        class="fa fa-check"
                                                        aria-hidden="true"
                                                    ></i
                                                ></span>
                                                <span
                                                    class="badge badge-warning"
                                                    v-if="k.verified == false"
                                                    @click="
                                                        verifyEducationPrompt(k)
                                                    "
                                                    ><i
                                                        class="fa fa-exclamation-circle"
                                                        aria-hidden="true"
                                                    ></i
                                                ></span>
                                            </td>
                                            <td>
                                                <p>
                                                    <button
                                                        class="btn btn-primary fa fa-edit"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        @click="
                                                            editEducationalHistory(
                                                                k
                                                            )
                                                        "
                                                    ></button>
                                                </p>
                                                <p>
                                                    <button
                                                        class="btn btn-danger fa fa-trash"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        @click="
                                                            deleteEducationalHistory(
                                                                k.id
                                                            )
                                                        "
                                                    ></button>
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div class="card card-secondary card-outline">
                            <div class="card-header">
                                <b>Employment History</b>
                                <button
                                    class="btn btn-primary float-right"
                                    v-if="
                                        lead_profile_id != '' &&
                                        lead_profile_id != null
                                    "
                                    @click="updateEmploymentHistory"
                                >
                                    <i class="fa fa-plus"></i> Add Experience
                                </button>
                            </div>
                            <div class="card-body overflow-auto">
                                <table
                                    class="table table-striped table-bordered table-hover"
                                >
                                    <thead>
                                        <tr>
                                            <th>Title</th>
                                            <th>Organisation</th>
                                            <th>DOJ</th>
                                            <th>DOL</th>
                                            <th
                                                v-if="
                                                    $gate.isSysAdmin() ||
                                                    $gate.isHRAdmin() ||
                                                    $gate.isMISAdmin() ||
                                                    $gate.isSecondaryMISAdmin()
                                                "
                                            >
                                                Verification
                                            </th>
                                            <th>Manage</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr
                                            v-for="j in employment_history"
                                            :key="j.id"
                                        >
                                            <td>{{ j.job_title }}</td>
                                            <td>{{ j.organisation }}</td>
                                            <td>
                                                {{ j.joining_date | smallDate }}
                                            </td>
                                            <td
                                                v-if="j.completion_date != null"
                                            >
                                                {{
                                                    j.completion_date
                                                        | smallDate
                                                }}
                                            </td>
                                            <td
                                                v-if="j.completion_date == null"
                                            >
                                                Ongoing
                                            </td>
                                            <td
                                                v-if="
                                                    $gate.isSysAdmin() ||
                                                    $gate.isHRAdmin() ||
                                                    $gate.isMISAdmin() ||
                                                    $gate.isSecondaryMISAdmin()
                                                "
                                            >
                                                <span
                                                    class="badge badge-success"
                                                    v-if="j.verified == true"
                                                    @click="
                                                        verifyEmploymentPrompt(
                                                            j
                                                        )
                                                    "
                                                    ><i
                                                        class="fa fa-check"
                                                        aria-hidden="true"
                                                    ></i
                                                ></span>
                                                <span
                                                    class="badge badge-warning"
                                                    v-if="j.verified == false"
                                                    @click="
                                                        verifyEmploymentPrompt(
                                                            j
                                                        )
                                                    "
                                                    ><i
                                                        class="fa fa-exclamation-circle"
                                                        aria-hidden="true"
                                                    ></i
                                                ></span>
                                            </td>
                                            <td>
                                                <p>
                                                    <button
                                                        class="btn btn-primary fa fa-edit"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        @click="
                                                            editEmploymentHistory(
                                                                j
                                                            )
                                                        "
                                                    ></button>
                                                </p>
                                                <p>
                                                    <button
                                                        class="btn btn-danger fa fa-trash"
                                                        style="
                                                            width: 100% !important;
                                                        "
                                                        @click="
                                                            deleteEmploymentHistory(
                                                                j.id
                                                            )
                                                        "
                                                    ></button>
                                                </p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-md-6">
                                <div class="card card-secondary card-outline">
                                    <div class="card-header">
                                        <b>Languages Known</b>
                                        <button
                                            class="btn btn-primary float-right"
                                            v-if="
                                                lead_profile_id != '' &&
                                                lead_profile_id != null
                                            "
                                            @click="updateLanguageSkill"
                                        >
                                            <i class="fa fa-plus"></i> Add
                                        </button>
                                    </div>
                                    <div class="card-body overflow-auto">
                                        <table
                                            class="table table-striped table-bordered table-hover"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Language</th>
                                                    <th>Level</th>
                                                    <th
                                                        v-if="
                                                            $gate.isSysAdmin() ||
                                                            $gate.isHRAdmin() ||
                                                            $gate.isMISAdmin() ||
                                                            $gate.isSecondaryMISAdmin()
                                                        "
                                                    >
                                                        Check
                                                    </th>
                                                    <th>
                                                        <i
                                                            class="fa fa-cog"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="j in user_language_skills"
                                                    :key="j.id"
                                                >
                                                    <td>{{ j.language }}</td>
                                                    <td>
                                                        {{ j.proficiency }}
                                                    </td>
                                                    <td
                                                        v-if="
                                                            $gate.isSysAdmin() ||
                                                            $gate.isHRAdmin() ||
                                                            $gate.isMISAdmin() ||
                                                            $gate.isSecondaryMISAdmin()
                                                        "
                                                    >
                                                        <span
                                                            class="badge badge-success"
                                                            v-if="
                                                                j.verified ==
                                                                true
                                                            "
                                                            @click="
                                                                verifyLanguagePrompt(
                                                                    j
                                                                )
                                                            "
                                                            ><i
                                                                class="fa fa-check"
                                                                aria-hidden="true"
                                                            ></i
                                                        ></span>
                                                        <span
                                                            class="badge badge-warning"
                                                            v-if="
                                                                j.verified ==
                                                                false
                                                            "
                                                            @click="
                                                                verifyLanguagePrompt(
                                                                    j
                                                                )
                                                            "
                                                            ><i
                                                                class="fa fa-exclamation-circle"
                                                                aria-hidden="true"
                                                            ></i
                                                        ></span>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <button
                                                                class="btn btn-primary fa fa-edit"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    editEducationalHistory(
                                                                        k
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                        <p>
                                                            <button
                                                                class="btn btn-danger fa fa-trash"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    deleteUserLanguage(
                                                                        j.id
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card card-secondary card-outline">
                                    <div class="card-header">
                                        <b>Skills</b>
                                        <button
                                            class="btn btn-primary float-right"
                                            v-if="
                                                lead_profile_id != '' &&
                                                lead_profile_id != null
                                            "
                                            @click="updateSkill"
                                        >
                                            <i class="fa fa-plus"></i> Add
                                        </button>
                                    </div>
                                    <div class="card-body overflow-auto">
                                        <table
                                            class="table table-striped table-bordered table-hover"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Skill</th>
                                                    <th>Level</th>
                                                    <th
                                                        v-if="
                                                            $gate.isSysAdmin() ||
                                                            $gate.isHRAdmin() ||
                                                            $gate.isMISAdmin() ||
                                                            $gate.isSecondaryMISAdmin()
                                                        "
                                                    >
                                                        Check
                                                    </th>
                                                    <th>
                                                        <i
                                                            class="fa fa-cog"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="j in user_skills"
                                                    :key="j.id"
                                                >
                                                    <td>{{ j.skill }}</td>
                                                    <td>
                                                        {{ j.proficiency }}
                                                    </td>
                                                    <td
                                                        v-if="
                                                            $gate.isSysAdmin() ||
                                                            $gate.isHRAdmin() ||
                                                            $gate.isMISAdmin() ||
                                                            $gate.isSecondaryMISAdmin()
                                                        "
                                                    >
                                                        <span
                                                            class="badge badge-success"
                                                            v-if="
                                                                j.verified ==
                                                                true
                                                            "
                                                            @click="
                                                                verifySkillPrompt(
                                                                    j
                                                                )
                                                            "
                                                            ><i
                                                                class="fa fa-check"
                                                                aria-hidden="true"
                                                            ></i
                                                        ></span>
                                                        <span
                                                            class="badge badge-warning"
                                                            v-if="
                                                                j.verified ==
                                                                false
                                                            "
                                                            @click="
                                                                verifySkillPrompt(
                                                                    j
                                                                )
                                                            "
                                                            ><i
                                                                class="fa fa-exclamation-circle"
                                                                aria-hidden="true"
                                                            ></i
                                                        ></span>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <button
                                                                class="btn btn-primary fa fa-edit"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    editEducationalHistory(
                                                                        k
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                        <p>
                                                            <button
                                                                class="btn btn-danger fa fa-trash"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    deleteUserSkill(
                                                                        j.id
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card card-secondary card-outline">
                                    <div class="card-header">
                                        <b>Government ID Information</b>
                                        <button
                                            class="btn btn-primary float-right"
                                            v-if="
                                                lead_profile_id != '' &&
                                                lead_profile_id != null
                                            "
                                            @click="updateEmploymentHistory"
                                        >
                                            <i class="fa fa-plus"></i> Add
                                        </button>
                                    </div>
                                    <div class="card-body overflow-auto">
                                        <table
                                            class="table table-striped table-bordered table-hover"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Gov ID</th>
                                                    <th>ID #</th>
                                                    <th>
                                                        <i
                                                            class="fa fa-cog"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="j in user_gov_docs"
                                                    :key="j.id"
                                                >
                                                    <td>
                                                        <p>
                                                            {{ j.gov_id_name }}
                                                        </p>
                                                        <p>
                                                            {{ j.expires_on }}
                                                        </p>
                                                        <p>
                                                            {{
                                                                j.supporting_document
                                                            }}
                                                        </p>
                                                    </td>
                                                    <td>
                                                        {{ j.id_number }}
                                                        <span
                                                            v-if="
                                                                $gate.isSysAdmin() ||
                                                                $gate.isHRAdmin() ||
                                                                $gate.isMISAdmin() ||
                                                                $gate.isSecondaryMISAdmin()
                                                            "
                                                        >
                                                            <span
                                                                class="badge badge-success"
                                                                v-if="
                                                                    j.verified ==
                                                                    true
                                                                "
                                                                @click="
                                                                    verifyGovDocumentPrompt(
                                                                        j
                                                                    )
                                                                "
                                                                ><i
                                                                    class="fa fa-check"
                                                                    aria-hidden="true"
                                                                ></i
                                                            ></span>
                                                            <span
                                                                class="badge badge-warning"
                                                                v-if="
                                                                    j.verified ==
                                                                    false
                                                                "
                                                                @click="
                                                                    verifyGovDocumentPrompt(
                                                                        j
                                                                    )
                                                                "
                                                                ><i
                                                                    class="fa fa-exclamation-circle"
                                                                    aria-hidden="true"
                                                                ></i
                                                            ></span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <button
                                                                class="btn btn-primary fa fa-edit"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    editEducationalHistory(
                                                                        k
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                        <p>
                                                            <button
                                                                class="btn btn-danger fa fa-trash"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    deleteUserGovDoc(
                                                                        j.id
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card card-secondary card-outline">
                                    <div class="card-header">
                                        <b>Personal Interests</b>
                                        <button
                                            class="btn btn-primary float-right"
                                            v-if="
                                                lead_profile_id != '' &&
                                                lead_profile_id != null
                                            "
                                            @click="updateInterest"
                                        >
                                            <i class="fa fa-plus"></i> Add
                                        </button>
                                    </div>
                                    <div class="card-body overflow-auto">
                                        <table
                                            class="table table-striped table-bordered table-hover"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Interest</th>
                                                    <th>
                                                        <i
                                                            class="fa fa-cog"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="j in user_interests"
                                                    :key="j.id"
                                                >
                                                    <td>
                                                        {{ j.interest }}
                                                        <span
                                                            v-if="
                                                                $gate.isSysAdmin() ||
                                                                $gate.isHRAdmin() ||
                                                                $gate.isMISAdmin() ||
                                                                $gate.isSecondaryMISAdmin()
                                                            "
                                                        >
                                                            <span
                                                                class="badge badge-success"
                                                                v-if="
                                                                    j.verified ==
                                                                    true
                                                                "
                                                                @click="
                                                                    verifyInterestPrompt(
                                                                        j
                                                                    )
                                                                "
                                                                ><i
                                                                    class="fa fa-check"
                                                                    aria-hidden="true"
                                                                ></i
                                                            ></span>
                                                            <span
                                                                class="badge badge-warning"
                                                                v-if="
                                                                    j.verified ==
                                                                    false
                                                                "
                                                                @click="
                                                                    verifyUserInterestsPrompt(
                                                                        j
                                                                    )
                                                                "
                                                                ><i
                                                                    class="fa fa-exclamation-circle"
                                                                    aria-hidden="true"
                                                                ></i
                                                            ></span>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <button
                                                                class="btn btn-danger fa fa-trash"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    deleteUserInterest(
                                                                        j.id
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="card card-secondary card-outline">
                                    <div class="card-header">
                                        <b>Banking Information</b>
                                        <button
                                            class="btn btn-primary float-right"
                                            v-if="
                                                lead_profile_id != '' &&
                                                lead_profile_id != null
                                            "
                                            @click="updateEmploymentHistory"
                                        >
                                            <i class="fa fa-plus"></i> Add
                                        </button>
                                    </div>
                                    <div class="card-body overflow-auto">
                                        <table
                                            class="table table-striped table-bordered table-hover"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Bank Info</th>
                                                    <th>Account Details</th>
                                                    <th
                                                        v-if="
                                                            $gate.isSysAdmin() ||
                                                            $gate.isHRAdmin() ||
                                                            $gate.isMISAdmin() ||
                                                            $gate.isSecondaryMISAdmin()
                                                        "
                                                    >
                                                        Check
                                                    </th>
                                                    <th>
                                                        <i
                                                            class="fa fa-cog"
                                                            aria-hidden="true"
                                                        ></i>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr
                                                    v-for="j in user_banking_details"
                                                    :key="j.id"
                                                >
                                                    <td>
                                                        <p>{{ j.bank_name }}</p>
                                                        <p>{{ j.branch }}</p>
                                                        <p>
                                                            <!--                                                            {{-->
                                                            <!--                                                                j.supporting_document_url-->
                                                            <!--                                                            }}-->
                                                        </p>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            Account:
                                                            {{
                                                                j.account_number
                                                            }}
                                                        </p>
                                                        <p>
                                                            IFSC:
                                                            {{ j.ifsc_number }}
                                                        </p>
                                                    </td>
                                                    <td
                                                        v-if="
                                                            $gate.isSysAdmin() ||
                                                            $gate.isHRAdmin() ||
                                                            $gate.isMISAdmin() ||
                                                            $gate.isSecondaryMISAdmin()
                                                        "
                                                    >
                                                        <span
                                                            class="badge badge-success"
                                                            v-if="
                                                                j.verified ==
                                                                true
                                                            "
                                                            @click="
                                                                verifyBankingInfoPrompt(
                                                                    j
                                                                )
                                                            "
                                                            ><i
                                                                class="fa fa-check"
                                                                aria-hidden="true"
                                                            ></i
                                                        ></span>
                                                        <span
                                                            class="badge badge-warning"
                                                            v-if="
                                                                j.verified ==
                                                                false
                                                            "
                                                            @click="
                                                                verifyBankingInfoPrompt(
                                                                    j
                                                                )
                                                            "
                                                            ><i
                                                                class="fa fa-exclamation-circle"
                                                                aria-hidden="true"
                                                            ></i
                                                        ></span>
                                                    </td>
                                                    <td>
                                                        <p>
                                                            <button
                                                                class="btn btn-primary fa fa-edit"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    editEducationalHistory(
                                                                        k
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                        <p>
                                                            <button
                                                                class="btn btn-danger fa fa-trash"
                                                                style="
                                                                    width: 100% !important;
                                                                "
                                                                @click="
                                                                    deleteUserBankingInfo(
                                                                        j.id
                                                                    )
                                                                "
                                                            ></button>
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="row" v-if="!$gate.isUser()">
                            <div class="col-md-12">
                                <div class="card">
                                    <div class="card-header">
                                        Last Recorded Device Log
                                    </div>
                                    <div class="card-body">
                                        <GmapMap
                                            :center="center"
                                            :zoom="12"
                                            style="width: 100%; height: 400px"
                                        >
                                            <GmapInfoWindow
                                                :options="infoOptions"
                                                :position="infoPosition"
                                                :opened="infoOpened"
                                                @closeclick="infoOpened = false"
                                            >
                                                <!--                                                {{ infoIndex }}-->
                                                <div
                                                    v-for="(
                                                        info, index
                                                    ) in infoContent"
                                                    :key="index"
                                                >
                                                    <p>
                                                        <strong>Emp ID:</strong>
                                                        {{ info.emp_id }}
                                                    </p>
                                                    <p>
                                                        <strong
                                                            >User Type:</strong
                                                        >
                                                        {{ info.user_type }} at
                                                        {{ info.branch }}
                                                    </p>
                                                    <p>
                                                        <strong
                                                            >App Info:</strong
                                                        >
                                                        {{ info.app_name }}
                                                        {{ info.app_version }}
                                                    </p>
                                                    <p>
                                                        <strong
                                                            >Logged in
                                                            from:</strong
                                                        >
                                                        {{ info.platform }}
                                                    </p>
                                                    <p>
                                                        <strong
                                                            >Logged in
                                                            On:</strong
                                                        >
                                                        {{
                                                            info.timestamp
                                                                | timeStamp
                                                        }}
                                                    </p>
                                                    <p>
                                                        <strong>Action:</strong>
                                                        {{ info.source }}
                                                    </p>
                                                </div>
                                            </GmapInfoWindow>
                                            <GmapMarker
                                                :key="index"
                                                v-for="(m, index) in markers"
                                                :position="m.position"
                                                :clickable="true"
                                                @mouseover="showInfo(m, index)"
                                                @mouseout="hideInfo()"
                                            />
                                            <!--                                            @click="center = m.position"-->
                                        </GmapMap>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <br />
            </div>
            <br />
            <br />
        </section>

        <div class="modal" tabindex="-1" role="dialog" id="profileImageModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Update Profile Image</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body overflow-auto">
                        <div class="main">
                            <div
                                class="dropzone-container"
                                @dragover="dragover"
                                @dragleave="dragleave"
                                @drop="drop"
                            >
                                <input
                                    type="file"
                                    multiple
                                    name="file"
                                    id="fileInput"
                                    class="hidden-input"
                                    @change="onChange"
                                    ref="file"
                                    accept=".pdf,.jpg,.jpeg,.png"
                                />

                                <label for="fileInput" class="file-label">
                                    <div v-if="isDragging">
                                        Release to drop files here.
                                    </div>
                                    <div v-else>
                                        Drop files here or <u>click here</u> to
                                        upload.
                                    </div>
                                </label>
                                <div
                                    class="preview-container mt-4"
                                    v-if="files.length"
                                >
                                    <div
                                        v-for="file in files"
                                        :key="file.name"
                                        class="preview-card"
                                    >
                                        <div>
                                            <img
                                                class="preview-img"
                                                :src="generateURL(file)"
                                            />
                                            <p>
                                                {{ file.name }} -
                                                {{
                                                    Math.round(
                                                        file.size / 1000
                                                    ) + "kb"
                                                }}
                                            </p>
                                        </div>
                                        <div>
                                            <button
                                                class="ml-2"
                                                type="button"
                                                @click="
                                                    remove(files.indexOf(file))
                                                "
                                                title="Remove file"
                                            >
                                                <b>×</b>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <small
                            ><b
                                >Upload square image with you in the center
                                position.</b
                            >
                            Image will change once verified by admin, it might
                            take upto 6 hours for verification to be completed.
                            Retry only if image hasn't appeared after 6
                            hours.</small
                        >
                    </div>
                    <div class="card-footer">
                        <button
                            class="btn btn-secondary"
                            @click="uploadProfileImage"
                            v-if="files != [] && files != null"
                            data-dismiss="modal"
                        >
                            Upload
                        </button>
                        <button class="btn btn-danger" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="adrsmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ heading }} Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateAddress">
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l1 ? 'has-error' : '',
                                ]"
                            >
                                <label>Address Line 1</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 1"
                                    v-model="aform.addr_l1"
                                />
                                <span
                                    v-if="errors.addr_l1"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l2 ? 'has-error' : '',
                                ]"
                            >
                                <label>Address Line 2</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 2"
                                    v-model="aform.addr_l2"
                                />
                                <span
                                    v-if="errors.addr_l2"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l3 ? 'has-error' : '',
                                ]"
                            >
                                <label>Address Line 3</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 3"
                                    v-model="aform.addr_l3"
                                />
                                <span
                                    v-if="errors.addr_l3"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.state ? 'has-error' : '',
                                ]"
                            >
                                <label>State *</label>
                                <v-select
                                    v-model="state_id"
                                    :options="states"
                                    placeholder="Select State"
                                    label="name"
                                    :reduce="(states) => states.id"
                                    @input="stateChange"
                                ></v-select>
                                <span
                                    v-if="errors.state"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid state.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>City *</label>
                                <v-select
                                    v-model="city_id"
                                    :options="cities"
                                    placeholder="Select City"
                                    label="name"
                                    :reduce="(cities) => cities.id"
                                    @input="cityChange"
                                ></v-select>
                                <span
                                    v-if="errors.city"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid city.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.pincode ? 'has-error' : '',
                                ]"
                            >
                                <label>Pincode *</label>
                                <input
                                    type="number"
                                    class="form-control"
                                    placeholder="Enter pincode"
                                    v-model="aform.pincode"
                                    min="100000"
                                />
                                <span
                                    v-if="errors.pincode"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid pincode.</span
                                >
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="verifyeducationmodal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update Education Verification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateEducationVerification">
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Verified:</label><br />
                                <label for="html">Yes</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="education_verification"
                                    value="1"
                                />
                                &nbsp; &nbsp;
                                <label for="css">No</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="education_verification"
                                    value="0"
                                />
                                <br />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="verifylangugageskillmodal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update Language Skills Verification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateLanguageVerification">
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Verified:</label><br />
                                <label for="html">Yes</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="language_verification"
                                    value="1"
                                />
                                &nbsp; &nbsp;
                                <label for="css">No</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="language_verification"
                                    value="0"
                                />
                                <br />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="verifyuserinterestmodal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update Interests Verification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateInterestVerification">
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Verified:</label><br />
                                <label for="html">Yes</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="interest_verification"
                                    value="1"
                                />
                                &nbsp; &nbsp;
                                <label for="css">No</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="interest_verification"
                                    value="0"
                                />
                                <br />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="verifyskillmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update Skill Verification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateSkillVerification">
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Verified:</label><br />
                                <label for="html">Yes</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="skill_verification"
                                    value="1"
                                />
                                &nbsp; &nbsp;
                                <label for="css">No</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="skill_verification"
                                    value="0"
                                />
                                <br />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="verifygovdocmodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update Government ID Verification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateGovDocVerification">
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Verified:</label><br />
                                <label for="html">Yes</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="user_gov_doc_verification"
                                    value="1"
                                />
                                &nbsp; &nbsp;
                                <label for="css">No</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="user_gov_doc_verification"
                                    value="0"
                                />
                                <br />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="verifybankinginfomodal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update Banking Info Verification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateBankInfoVerification">
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Verified:</label><br />
                                <label for="html">Yes</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="user_bank_verification"
                                    value="1"
                                />
                                &nbsp; &nbsp;
                                <label for="css">No</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="user_bank_verification"
                                    value="0"
                                />
                                <br />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="verifyemploymentmodal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Update Employment Verification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateEmploymentVerification">
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Verified:</label><br />
                                <label for="html">Yes</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="employment_verification"
                                    value="1"
                                />
                                &nbsp; &nbsp;
                                <label for="css">No</label>
                                <input
                                    type="radio"
                                    placeholder="Enter verification status"
                                    v-model="employment_verification"
                                    value="0"
                                />
                                <br />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="educationHistoryModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Educational Qualification Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateEducationalData">
                            <div
                                :class="[
                                    'form-group',
                                    errors.qualification_type
                                        ? 'has-error'
                                        : '',
                                ]"
                            >
                                <label>Qualification Type</label>
                                <select
                                    id="qualification_type"
                                    placeholder="Pick qualification type"
                                    class="form-control"
                                    v-model="eduform.qualification_type"
                                >
                                    <option value="High School">
                                        High School
                                    </option>
                                    <option value="Pre-Degree">
                                        Pre-Degree
                                    </option>
                                    <option value="Graduate Degree">
                                        Graduate Degree
                                    </option>
                                    <option value="Post Graduate Degree">
                                        Post Graduate Degree
                                    </option>
                                </select>
                                <span
                                    v-if="errors.qualification_type"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid type.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.specialization ? 'has-error' : '',
                                ]"
                            >
                                <label>Degree and/or Specialization</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter your degree and specialization"
                                    v-model="eduform.specialization"
                                />
                                <span
                                    v-if="errors.specialization"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid data.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.institution ? 'has-error' : '',
                                ]"
                            >
                                <label>Institution</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter the name of the institution"
                                    v-model="eduform.institution"
                                />
                                <span
                                    v-if="errors.institution"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.joining_date ? 'has-error' : '',
                                ]"
                            >
                                <label>Joining Date</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter joining date"
                                    v-model="eduform.joining_date"
                                />
                                <span
                                    v-if="errors.joining_date"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.completion_date ? 'has-error' : '',
                                ]"
                            >
                                <label>Completion Date</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter completion date"
                                    v-model="eduform.completion_date"
                                />
                                <span
                                    v-if="errors.completion_date"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid city.</span
                                >
                            </div>
                            <hr
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                class="dotted"
                            />
                            <!--                           <div v-if="$gate.isSysAdmin() || $gate.isHRAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin()" :class="['form-group', errors.city ? 'has-error' : '']">-->
                            <!--                               <label>Verified:</label><br>-->
                            <!--                               <label for="html">Yes</label>-->
                            <!--                               <input type="radio" placeholder="Enter verification status" v-model="eduform.verified" value="1">-->
                            <!--                               &nbsp; &nbsp;-->
                            <!--                               <label for="css">No</label>-->
                            <!--                               <input type="radio" placeholder="Enter verification status" v-model="eduform.verified" value="0">-->
                            <!--                               <br>-->
                            <!--                           </div>-->
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Notes</label>
                                <textarea
                                    class="form-control"
                                    placeholder="Internal Admin Notes - PRIVATE - Not visible to user"
                                    v-model="eduform.notes"
                                    rows="4"
                                ></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="interestModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">User Interest Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateInterestData">
                            <div
                                :class="[
                                    'form-group',
                                    errors.interestform ? 'has-error' : '',
                                ]"
                            >
                                <label>Interests *</label>
                                <v-select
                                    v-model="interestform.master_interest_id"
                                    :options="master_interests"
                                    placeholder="Select Interests"
                                    label="title"
                                    :reduce="
                                        (master_interests) =>
                                            master_interests.id
                                    "
                                ></v-select>
                                <span
                                    v-if="errors.city"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid interest.</span
                                >
                            </div>

                            <hr
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                class="dotted"
                            />
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.interestform ? 'has-error' : '',
                                ]"
                            >
                                <label>Notes</label>
                                <textarea
                                    class="form-control"
                                    placeholder="Internal Admin Notes - PRIVATE - Not visible to user"
                                    v-model="interestform.notes"
                                    rows="4"
                                ></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="skillModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">User Skill Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateSkillData">
                            <div
                                :class="[
                                    'form-group',
                                    errors.skillform ? 'has-error' : '',
                                ]"
                            >
                                <label>Skill *</label>
                                <v-select
                                    v-model="skillform.master_skill_id"
                                    :options="master_skills"
                                    placeholder="Select Skill"
                                    label="title"
                                    :reduce="
                                        (master_skills) => master_skills.id
                                    "
                                ></v-select>
                                <span
                                    v-if="errors.skillform"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid skill.</span
                                >
                            </div>

                            <div
                                :class="[
                                    'form-group',
                                    errors.skillform ? 'has-error' : '',
                                ]"
                            >
                                <label>Proficiency *</label>
                                <input
                                    type="range"
                                    class="form-range"
                                    min="0"
                                    max="5"
                                    v-model="skillform.proficiency"
                                    :id="skillform.proficiency"
                                />
                                <span
                                    v-if="errors.skillform"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid skill.</span
                                >
                            </div>
                            <hr
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                class="dotted"
                            />
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.skillform ? 'has-error' : '',
                                ]"
                            >
                                <label>Notes</label>
                                <textarea
                                    class="form-control"
                                    placeholder="Internal Admin Notes - PRIVATE - Not visible to user"
                                    v-model="skillform.notes"
                                    rows="4"
                                ></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="languageSkillModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            User Langugage Skill Details
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateLangugageSkillData">
                            <div
                                :class="[
                                    'form-group',
                                    errors.langform ? 'has-error' : '',
                                ]"
                            >
                                <label>Skill *</label>
                                <v-select
                                    v-model="langform.master_language_id"
                                    :options="master_languages"
                                    placeholder="Select Language"
                                    label="language"
                                    :reduce="
                                        (master_languages) =>
                                            master_languages.id
                                    "
                                ></v-select>
                                <span
                                    v-if="errors.langform"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid language.</span
                                >
                            </div>

                            <div
                                :class="[
                                    'form-group',
                                    errors.langform ? 'has-error' : '',
                                ]"
                            >
                                <label>Proficiency *</label>
                                <input
                                    type="range"
                                    class="form-range"
                                    min="0"
                                    max="5"
                                    v-model="langform.proficiency"
                                    :id="langform.proficiency"
                                />
                                <span
                                    v-if="errors.langform"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid language.</span
                                >
                            </div>
                            <hr
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                class="dotted"
                            />
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.langform ? 'has-error' : '',
                                ]"
                            >
                                <label>Notes</label>
                                <textarea
                                    class="form-control"
                                    placeholder="Internal Admin Notes - PRIVATE - Not visible to user"
                                    v-model="langform.notes"
                                    rows="4"
                                ></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="modal"
            tabindex="-1"
            role="dialog"
            id="employmentHistoryModal"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Employment History Details</h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form @submit.prevent="updateEmploymentData">
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l1 ? 'has-error' : '',
                                ]"
                            >
                                <label>Job Title:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 1"
                                    v-model="empform.job_title"
                                />
                                <span
                                    v-if="errors.title"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l2 ? 'has-error' : '',
                                ]"
                            >
                                <label>Organisation:</label>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Enter address line 2"
                                    v-model="empform.organisation"
                                />
                                <span
                                    v-if="errors.organisation"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l3 ? 'has-error' : '',
                                ]"
                            >
                                <label>Job Description:</label>
                                <!--                               <input type="text" class="form-control" placeholder="Enter address line 3" v-model="empform.description">-->
                                <textarea
                                    class="form-control"
                                    placeholder="Enter your job location, duties, responsibilities and any other data that might help us understand you better"
                                    v-model="empform.description"
                                    rows="4"
                                ></textarea>
                                <span
                                    v-if="errors.description"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.addr_l3 ? 'has-error' : '',
                                ]"
                            >
                                <label>Joining Date</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter joining date"
                                    v-model="empform.joining_date"
                                />
                                <span
                                    v-if="errors.joining_date"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid line.</span
                                >
                            </div>
                            <div
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Completion Date</label>
                                <input
                                    type="date"
                                    class="form-control"
                                    placeholder="Enter completion date"
                                    v-model="empform.completion_date"
                                />
                                <span
                                    v-if="errors.completion_date"
                                    :class="['badge bg-danger']"
                                    >Please enter a valid city.</span
                                >
                            </div>
                            <hr
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                class="dotted"
                            />
                            <!--                           <div v-if="$gate.isSysAdmin() || $gate.isHRAdmin() || $gate.isMISAdmin() || $gate.isSecondaryMISAdmin()" :class="['form-group', errors.city ? 'has-error' : '']">-->
                            <!--                               <label>Verified:</label><br>-->
                            <!--                               <label for="html">Yes</label>-->
                            <!--                               <input type="radio" placeholder="Enter verification status" v-model="empform.verified" value="1">-->
                            <!--                               &nbsp; &nbsp;-->
                            <!--                               <label for="css">No</label>-->
                            <!--                               <input type="radio" placeholder="Enter verification status" v-model="empform.verified" value="0">-->
                            <!--                               <br>-->
                            <!--                           </div>-->
                            <div
                                v-if="
                                    $gate.isSysAdmin() ||
                                    $gate.isHRAdmin() ||
                                    $gate.isMISAdmin() ||
                                    $gate.isSecondaryMISAdmin()
                                "
                                :class="[
                                    'form-group',
                                    errors.city ? 'has-error' : '',
                                ]"
                            >
                                <label>Notes</label>
                                <textarea
                                    class="form-control"
                                    placeholder="Internal Admin Notes - PRIVATE - Not visible to user"
                                    v-model="empform.notes"
                                    rows="4"
                                ></textarea>
                            </div>
                            <div class="form-group">
                                <button class="btn btn-primary" type="submit">
                                    Submit
                                </button>
                            </div>
                        </form>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal" tabindex="-1" role="dialog" id="searchModal">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Associating with your customer profile. Please
                            choose Profile
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body overflow-auto">
                        <b>{{ searchs }}</b> Please choose your ID from our
                        existing customer data to own your data. If your
                        information isn't available, dismiss this dialog box,
                        fill your data in the form and submit it.
                        <br />
                        <table
                            class="table table-striped table-bordered table-hover"
                        >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Phone 1</th>
                                    <th>Phone 2</th>
                                    <th>Phone 3</th>
                                    <th>Phone 4</th>
                                    <th>Set</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="j in profiles" :key="j.id">
                                    <td>{{ j.name }}</td>
                                    <td>{{ j.mobile }}</td>
                                    <td>{{ j.alt_mobile }}</td>
                                    <td>{{ j.phone }}</td>
                                    <td>{{ j.alt_phone }}</td>
                                    <td>
                                        <button
                                            class="btn btn-success fa fa-check-circle"
                                            @click="set(j)"
                                        ></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close and Proceed to Create New
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isSysAdmin()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
import moment from "moment";
import loading from "vue-full-loading";
export default {
    mounted() {
        console.log("Customer Profile mounted.");
    },

    components: { loading },

    created() {
        this.backdoor++;
        this.branch = window.user.branch;
        this.usertype = window.user.user_type;
        this.profile_pic = window.user.profile_pic;
        this.lead_profile_id = window.user.lead_id;
        this.user_id = window.user.id;
        if (
            typeof this.$route.params.user_id !== "undefined" &&
            this.$route.params.lead_profile_id !== "undefined"
        ) {
            this.user_id = this.$route.params.user_id;
            this.lead_profile_id = this.$route.params.lead_profile_id;
            if (typeof this.$route.params.phone != "undefined") {
                this.userphone = this.$route.params.phone;
                this.getLead();
            } else {
                this.getLead();
                this.userphone = this.user_info.phone;
            }
        } else if (
            typeof this.$route.params.user_id === "undefined" &&
            this.lead_profile_id != "" &&
            this.lead_profile_id != null
        ) {
            if (typeof this.$route.params.phone != "undefined") {
                this.userphone = this.$route.params.phone;
            } else {
                this.userphone = window.user.phone;
            }
            this.getLead();
        } else {
            if (typeof this.$route.params.phone != "undefined") {
                this.userphone = this.$route.params.phone;
            } else {
                this.userphone = window.user.phone;
            }
            this.getLead();
        }
        this.getStates();
        this.getMasterInterests();
        this.getMasterSkills();
        this.getMasterLanguages();
    },

    data() {
        return {
            usertype: "",
            profile_pic: "",
            states: [],
            cities: [],
            center: { lat: 10.850516, lng: 76.27108 },
            infoPosition: null,
            infoContent: null,
            infoIndex: null,
            infoOpened: false,
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35,
                },
            },
            currentPlace: null,
            markers: [],
            places: [],
            form: new Form({
                name: "",
                uid: "",
                gender: "",
                mobile: "",
                alt_mobile: "",
                phone: "",
                alt_phone: "",
                email: "",
                alt_email: "",
                dob: "",
                membership_id: "",
                category: "",
                area: "",
                doa: "",
                blood_group: "",
                marital_status: "",
                wedding_anniversary: "",
                id: "",
            }),
            lead_profile_id: "",
            last_device_log: [],
            user_id: "",
            user_data: [],
            errors: [],
            heading: "",
            allow: false,
            file: "",
            searchs: "",
            aform: new Form({
                profile_id: "",
                addr_l1: "",
                addr_l2: "",
                addr_l3: "",
                city: "",
                state: "",
                pincode: "",
                id: "",
            }),
            eduform: new Form({
                id: "",
                lead_profile_id: "",
                user_id: "",
                notes: "",
                qualification_type: "",
                specialization: "",
                institution: "",
                joining_date: "",
                completion_date: "",
                supporting_document: "",
            }),
            empform: new Form({
                id: "",
                lead_profile_id: "",
                job_title: "",
                user_id: "",
                notes: "",
                description: "",
                organisation: "",
                joining_date: "",
                completion_date: "",
                supporting_document: "",
            }),
            skillform: new Form({
                id: "",
                lead_profile_id: "",
                master_skill_id: "",
                user_id: "",
                notes: "",
                proficiency: "",
                supporting_document: "",
            }),
            interestform: new Form({
                id: "",
                lead_profile_id: "",
                master_interest_id: "",
                user_id: "",
                notes: "",
                proficiency: "",
                supporting_document: "",
            }),
            langform: new Form({
                id: "",
                lead_profile_id: "",
                user_id: "",
                notes: "",
                master_language_id: "",
                proficiency: "",
                supporting_document: "",
            }),
            bankform: new Form({
                id: "",
                lead_profile_id: "",
                bank_id: "",
                user_id: "",
                notes: "",
                branch: "",
                account_number: "",
                ifsc_number: "",
                salary_account: "",
                supporting_document: "",
            }),
            govdocform: new Form({
                id: "",
                lead_profile_id: "",
                user_id: "",
                notes: "",
                gov_id: "",
                id_number: "",
                expires_on: "",
                supporting_document: "",
            }),
            employment_item: "",
            education_item: "",
            language_item: "",
            skill_item: "",
            interest_item: "",
            banking_item: "",
            gov_doc_item: "",
            user_info: [],
            employment_history: [],
            employment_verification: "",
            education_verification: "",
            language_verification: "",
            interest_verification: "",
            skill_verification: "",
            user_bank_verification: "",
            user_gov_doc_verification: "",
            user_language_skills: [],
            user_interests: [],
            user_skills: [],
            user_banking_details: [],
            user_gov_docs: [],
            educational_history: [],
            master_skills: [],
            master_interests: [],
            master_languages: [],
            master_banks: [],
            master_documents: [],
            profile_image: "",
            profiles: [],
            addresses: [],
            isDragging: false,
            files: [],
            lshow: "false",
            llabel: "",
        };
    },
    methods: {
        setPlace(place) {
            this.currentPlace = place;
        },
        getStates() {
            axios.post("/api/getStates", { country: 101 }).then((response) => {
                this.states = response.data;
            });
        },

        getCities() {
            axios
                .post("/api/getCities", { state: this.state_id })
                .then((response) => {
                    this.cities = response.data;
                });
        },

        stateChange() {
            var state = this.states.find((s) => s.id == this.state_id);
            this.aform.state = state.state_code;
            this.getCities();
        },

        getStatePrefix() {
            if (this.customertype == "b2c")
                var state = this.addresses.find(
                    (a) => a.id == this.billing_address
                ).state;
            else var state = this.b2bcustomer.BillingAddress.State;
            axios
                .post("/api/getStatePrefix", { state: state })
                .then((response) => {
                    this.placeofsupply = response.data;
                });
        },

        cityChange() {
            var city = this.cities.find((s) => s.id == this.city_id);
            this.aform.city = city.name;
        },

        getLead() {
            axios
                .post("/api/getMyLead", { id: this.user_id })
                .then((response) => {
                    // console.log(response);
                    if (response.data != "" && response.data.uid != null) {
                        console.log(
                            "Filling Sheet with existing Lead Profile Data..."
                        );
                        this.form.fill(response.data);
                        this.user_info = response.data.user;
                        this.lead_profile_id = response.data.id;
                        this.getAddresses();
                        this.loadEmploymentHistory();
                        this.loadEducationalHistory();
                        this.loadUserInterests();
                        this.loadUserSkills();
                        this.loadLanguageSkills();
                        this.loadUserBankingInfo();
                        this.loadUserGovDocs();
                        this.getLastKnownDeviceLog();
                        if (this.form.dob != null) {
                            var dob = moment(this.form.dob).add(24, "hours");
                            this.form.dob = moment(dob)
                                .utc()
                                .format("YYYY-MM-DD");
                        } else this.form.dob = "";
                        if (this.form.wedding_anniversary != null) {
                            var wed = moment(this.form.wedding_anniversary).add(
                                24,
                                "hours"
                            );
                            this.form.wedding_anniversary = moment(wed)
                                .utc()
                                .format("YYYY-MM-DD");
                        } else this.form.wedding_anniversary = "";
                    } else if (
                        response.data == "" ||
                        response.status != 200 ||
                        response.data.uid == null
                    ) {
                        this.searchProfile();
                    }
                });
        },

        set(j) {
            this.form.fill(j);
            this.updateUserLeadId();
            $("#searchModal").modal("hide");
        },

        updateUserLeadId() {
            this.searchs = "Updating ID for User...";
            $("#searchModal").modal("show");
            axios
                .post("/api/updateUserLeadID", {
                    id: this.user_id,
                    lead_id: this.form.id,
                })
                .then((response) => {
                    this.user_info = response.data;
                    console.log(this.user_info);
                    this.lead_profile_id = this.user_info.lead_id;
                    this.$route.params.lead_profile_id = this.user_info.lead_id;
                    this.searchs = "Search Complete!";
                });
        },

        getMasterInterests() {
            axios.post("/api/getInterests").then((response) => {
                this.master_interests = response.data;
            });
        },

        getMasterSkills() {
            axios.post("/api/getSkills").then((response) => {
                this.master_skills = response.data;
            });
        },

        getMasterLanguages() {
            axios.post("/api/getLanguages").then((response) => {
                this.master_languages = response.data;
            });
        },

        verifyLanguagePrompt(j) {
            console.log("Verifying Langugage Entry");
            this.language_item = j.id;
            this.language_verification = j.verified;
            $("#verifylangugageskillmodal").modal("show");
        },

        verifyInterestPrompt(j) {
            console.log("Verifying Interest Entry");
            this.interest_item = j.id;
            this.interest_verification = j.verified;
            $("#verifyinterestmodal").modal("show");
        },

        verifyGovDocumentPrompt(j) {
            console.log("Verifying Government ID Entry");
            this.gov_doc_item = j.id;
            this.user_gov_doc_verification = j.verified;
            $("#verifygovdocmodal").modal("show");
        },

        verifyBankingInfoPrompt(j) {
            console.log("Verifying Banking Info Entry");
            this.banking_item = j.id;
            this.user_bank_verification = j.verified;
            $("#verifybankinginfomodal").modal("show");
        },

        verifySkillPrompt(j) {
            console.log("Verifying Skill Entry");
            this.skill_item = j.id;
            this.skill_verification = j.verified;
            $("#verifyskillmodal").modal("show");
        },

        verifyEmploymentPrompt(j) {
            console.log("Verifying Employment History Entry");
            this.employment_item = j.id;
            this.employment_verification = j.verified;
            $("#verifyemploymentmodal").modal("show");
        },

        verifyEducationPrompt(k) {
            console.log("Verifying Educational History Entry");
            this.education_item = k.id;
            this.education_verification = k.verified;
            $("#verifyeducationmodal").modal("show");
        },

        loadEmploymentHistory() {
            console.log("Loaded Employment History Entry");
            axios
                .post("/api/getEmploymentHistory", { id: this.form.id })
                .then((response) => {
                    this.employment_history = response.data;
                });
        },

        loadEducationalHistory() {
            console.log("Loaded Educational History");
            axios
                .post("/api/getEducationalHistory", { id: this.form.id })
                .then((response) => {
                    this.educational_history = response.data;
                });
        },

        loadLanguageSkills() {
            console.log("Loaded User's Language Skills");
            axios
                .post("/api/getUserLanguages", { id: this.form.id })
                .then((response) => {
                    this.user_language_skills = response.data;
                });
        },

        loadUserInterests() {
            console.log("Loaded User's Interests");
            axios
                .post("/api/getUserInterests", { id: this.form.id })
                .then((response) => {
                    this.user_interests = response.data;
                });
        },

        loadUserSkills() {
            console.log("Loaded User's Skills");
            axios
                .post("/api/getUserSkills", { id: this.form.id })
                .then((response) => {
                    this.user_skills = response.data;
                });
        },

        loadUserBankingInfo() {
            console.log("Loaded User's Banking Info");
            axios
                .post("/api/getUserBankingInfo", { id: this.form.id })
                .then((response) => {
                    this.user_banking_details = response.data;
                });
        },

        loadUserGovDocs() {
            console.log("Loaded User's Government IDs");
            axios
                .post("/api/getUserUniqueDocuments", { id: this.form.id })
                .then((response) => {
                    this.user_gov_docs = response.data;
                });
        },

        deleteEmploymentHistory(id) {
            axios
                .post("/api/deleteEmploymentHistory", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Employment Data Deleted",
                    });
                    this.loadEmploymentHistory();
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        deleteEducationalHistory(id) {
            axios
                .post("/api/deleteEducationalHistory", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Education Data Deleted",
                    });
                    this.loadEducationalHistory();
                })
                .catch(() => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                });
        },

        deleteUserInterest(id) {
            axios
                .post("/api/deleteUserInterest", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Interest Deleted",
                    });
                    this.loadUserInterests();
                })
                .catch(() => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                });
        },

        deleteUserSkill(id) {
            axios
                .post("/api/deleteUserSkill", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Skill Deleted",
                    });
                    this.loadUserSkills();
                })
                .catch(() => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                });
        },

        deleteUserLanguage(id) {
            axios
                .post("/api/deleteUserLanguage", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Language Deleted",
                    });
                    this.loadLanguageSkills();
                })
                .catch(() => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                });
        },

        deleteUserBankingInfo(id) {
            axios
                .post("/api/deleteUserBankingInfo", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Banking Data Deleted",
                    });
                    this.loadUserBankingInfo();
                })
                .catch(() => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                });
        },

        deleteUserGovDoc(id) {
            axios
                .post("/api/deleteUserUniqueDocument", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Government ID Data Deleted",
                    });
                    this.loadUserGovDocs();
                })
                .catch(() => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                });
        },

        updateEmploymentVerification(id) {
            axios
                .post("/api/updateEmploymentVerification", {
                    id: this.employment_item,
                    verified: this.employment_verification,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Employment Data Updated",
                    });
                    this.loadEmploymentHistory();
                    $("#verifyemploymentmodal").modal("hide");
                    this.employment_verification = "";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        updateEducationVerification() {
            axios
                .post("/api/updateEducationalHistoryVerification", {
                    id: this.education_item,
                    verified: this.education_verification,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Education Data Verification Updated",
                    });
                    this.loadEducationalHistory();
                    $("#verifyeducationmodal").modal("hide");
                    this.education_verification = "";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        updateSkillVerification() {
            axios
                .post("/api/updateUserSkillVerification", {
                    id: this.skill_item,
                    verified: this.skill_verification,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Skill Verification Updated",
                    });
                    this.loadUserSkills();
                    $("#verifyskillmodal").modal("hide");
                    this.skill_verification = "";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        updateInterestVerification() {
            axios
                .post("/api/updateUserInterestVerification", {
                    id: this.interest_item,
                    verified: this.interest_verification,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Interest Verification Updated",
                    });
                    this.loadUserInterests();
                    $("#verifyuserinterestmodal").modal("hide");
                    this.interest_verification = "";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        updateLanguageVerification() {
            axios
                .post("/api/updateUserLanguageVerification", {
                    id: this.language_item,
                    verified: this.language_verification,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Language Skill Verification Updated",
                    });
                    this.loadLanguageSkills();
                    $("#verifylangugageskillmodal").modal("hide");
                    this.language_verification = "";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        updateBankInfoVerification() {
            axios
                .post("/api/updateUserBankingInfoVerification", {
                    id: this.banking_item,
                    verified: this.user_bank_verification,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Banking Data Verification Updated",
                    });
                    this.loadUserBankingInfo();
                    $("#verifybankinginfomodal").modal("hide");
                    this.user_bank_verification = "";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        updateGovDocVerification() {
            axios
                .post("/api/updateUserUniqueDocumentVerification", {
                    id: this.gov_doc_item,
                    verified: this.user_gov_doc_verification,
                })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Government ID Data Verification Updated",
                    });
                    this.loadUserGovDocs();
                    $("#verifygovdocmodal").modal("hide");
                    this.user_gov_doc_verification = "";
                })
                .catch(() => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                });
        },

        updateEmploymentHistory() {
            console.log("Adding Employment History Entry");
            this.empform.lead_profile_id = this.lead_profile_id;
            this.empform.user_id = this.form.uid;
            $("#employmentHistoryModal").modal("show");
            // axios.post("/api/updateUserLeadID", {id: this.form.id})
            //     .then(response => {
            //         this.user_data = response.data;
            //         this.lead_profile_id = this.user_data.lead_id;
            //         this.searchs = "Search Complete!";
            //     })
        },

        updateEducationalHistory() {
            console.log("Adding Educational History Entry");
            this.eduform.lead_profile_id = this.lead_profile_id;
            this.eduform.user_id = this.form.uid;
            $("#educationHistoryModal").modal("show");
            // axios.post("/api/updateUserLeadID", {id: this.form.id})
            //     .then(response => {
            //         this.user_data = response.data;
            //         this.lead_profile_id = this.user_data.lead_id;
            //         this.searchs = "Search Complete!";
            //     })
        },

        updateInterest() {
            console.log("Adding Interest Entry");
            this.interestform.lead_profile_id = this.lead_profile_id;
            this.interestform.user_id = this.form.uid;
            $("#interestModal").modal("show");
        },

        updateLanguageSkill() {
            console.log("Adding Langugage Entry");
            this.langform.lead_profile_id = this.lead_profile_id;
            this.langform.user_id = this.form.uid;
            $("#languageSkillModal").modal("show");
        },

        updateSkill() {
            console.log("Adding Skill Entry");
            this.eduform.lead_profile_id = this.lead_profile_id;
            this.eduform.user_id = this.form.uid;
            $("#skillModal").modal("show");
        },

        updateBankingInfo() {
            console.log("Adding Banking Info Entry");
            this.eduform.lead_profile_id = this.lead_profile_id;
            this.eduform.user_id = this.form.uid;
            $("#bankingModal").modal("show");
        },

        updateGovDocInfo() {
            console.log("Adding Gov ID Info Entry");
            this.eduform.lead_profile_id = this.lead_profile_id;
            this.eduform.user_id = this.form.uid;
            $("#govDocModal").modal("show");
        },

        editEducationalHistory(education) {
            this.heading = "Edit";
            this.eduform.fill(education);
            var doj = moment(education.joining_date).add(24, "hours");
            this.eduform.joining_date = moment(doj).utc().format("YYYY-MM-DD");
            if (education.completion_date != null) {
                var dop = moment(education.completion_date).add(24, "hours");
                this.eduform.completion_date = moment(dop)
                    .utc()
                    .format("YYYY-MM-DD");
            } else this.eduform.completion_date = "";
            $("#educationHistoryModal").modal("show");
        },

        editEmploymentHistory(employment) {
            this.heading = "Edit";
            this.empform.fill(employment);
            var doj = moment(employment.joining_date).add(24, "hours");
            this.empform.joining_date = moment(doj).utc().format("YYYY-MM-DD");
            if (employment.completion_date != null) {
                var dop = moment(employment.completion_date).add(24, "hours");
                this.empform.completion_date = moment(dop)
                    .utc()
                    .format("YYYY-MM-DD");
            } else this.empform.completion_date = "";
            $("#employmentHistoryModal").modal("show");
        },

        updateEmploymentData() {
            this.empform.lead_profile_id = this.form.id;
            this.empform.user_id = this.form.uid;
            this.empform
                .post("/api/addEmploymentHistory")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Employment Data Updated",
                        });
                        this.errors = [];
                        this.loadEmploymentHistory();
                        this.empform.reset();
                        $("#employmentHistoryModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        updateEducationalData() {
            this.eduform.lead_profile_id = this.form.id;
            this.eduform.user_id = this.form.uid;
            this.eduform
                .post("/api/addEducationalHistory")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Education Data Updated",
                        });
                        this.errors = [];
                        this.loadEducationalHistory();
                        this.eduform.reset();
                        $("#educationHistoryModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        updateInterestData() {
            this.interestform.lead_profile_id = this.form.id;
            this.interestform.user_id = this.form.uid;
            this.interestform
                .post("/api/addUserInterest")
                .then((response) => {
                    if (response.status == 200) {
                        toast.fire({
                            icon: "success",
                            title: "User Interest Updated",
                        });
                        this.errors = [];
                        this.loadUserInterests();
                        this.interestform.reset();
                        $("#interestModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        updateSkillData() {
            this.skillform.lead_profile_id = this.form.id;
            this.skillform.user_id = this.form.uid;
            this.skillform
                .post("/api/addUserSkill")
                .then((response) => {
                    if (response.status == 200) {
                        toast.fire({
                            icon: "success",
                            title: "User Skill Updated",
                        });
                        this.errors = [];
                        this.loadUserSkills();
                        this.skillform.reset();
                        $("#skillModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        updateLangugageSkillData() {
            this.langform.lead_profile_id = this.form.id;
            this.langform.user_id = this.form.uid;
            this.langform
                .post("/api/addUserLanguage")
                .then((response) => {
                    if (response.status == 200) {
                        toast.fire({
                            icon: "success",
                            title: "User Langugage Updated",
                        });
                        this.errors = [];
                        this.loadLanguageSkills();
                        this.langform.reset();
                        $("#languageSkillModal").modal("hide");
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        getLastKnownDeviceLog() {
            console.log("Loaded Last Known Device Log");
            axios
                .post("/api/getLastKnownDeviceLog", { user_id: this.form.uid })
                .then((response) => {
                    this.last_device_log = response.data;
                    console.log(this.last_device_log.lat);
                    const marker = {
                        lat: parseFloat(this.last_device_log.lat),
                        lng: parseFloat(this.last_device_log.long),
                        emp_id: this.last_device_log.employee_id,
                        user_type: this.last_device_log.user_type,
                        branch: this.last_device_log.branch_code,
                        app_version: this.last_device_log.version,
                        platform: this.last_device_log.platform,
                        source: this.last_device_log.source,
                        app_name: this.last_device_log.app_name,
                        timestamp: this.last_device_log.created_at,
                    };
                    this.center = {
                        lat: parseFloat(this.last_device_log.lat),
                        lng: parseFloat(this.last_device_log.long),
                    };
                    this.markers.push({
                        position: marker,
                    });
                });
        },

        showInfo(log, index) {
            this.infoPosition = {
                lat: log.position.lat,
                lng: log.position.lng,
            };
            this.infoIndex = index;
            this.infoContent = log;
            this.infoOpened = true;
        },
        hideInfo() {
            this.infoOpened = false;
        },

        searchProfile() {
            this.searchs = "Searching...";
            console.log(this.userphone);
            $("#searchModal").modal("show");
            axios
                .post("/api/numberSearchProfiles", { number: this.userphone })
                .then((response) => {
                    this.profiles = response.data;
                    this.searchs = "Search Complete!";
                });
        },

        updateProfileImageModal() {
            $("#profileImageModal").modal("show");
        },

        updateCustomer() {
            if (this.lead_id == this.form.id) {
                this.form.uid = this.$userId;
                this.form
                    .post("/api/updateCustomer")
                    .then((response) => {
                        if (response.data == 200) {
                            toast.fire({
                                icon: "success",
                                title: "Details Updated",
                            });
                            this.getLead();
                            this.errors = [];
                        } else
                            toast.fire({
                                icon: "error",
                                title: "Operation Failed",
                            });
                    })
                    .catch((errors) => {
                        toast.fire({
                            icon: "error",
                            title: "Operation Failed",
                        });
                        this.errors = errors.response.data.errors;
                    });
            } else {
                this.form.uid = this.$userId;
                this.form
                    .post("/api/updateCustomer")
                    .then((response) => {
                        if (response.data == 200) {
                            toast.fire({
                                icon: "success",
                                title: "Details Updated",
                            });
                            this.getLead();
                            this.errors = [];
                        } else
                            toast.fire({
                                icon: "error",
                                title: "Operation Failed",
                            });
                    })
                    .catch((errors) => {
                        toast.fire({
                            icon: "error",
                            title: "Operation Failed",
                        });
                        this.errors = errors.response.data.errors;
                    });
            }
        },

        add() {
            this.heading = "Add";
            this.aform.profile_id = this.form.id;
            $("#adrsmodal").modal("show");
        },

        change(address) {
            this.heading = "Edit";
            this.aform.fill(address);
            $("#adrsmodal").modal("show");
        },

        deleteA(id) {
            axios
                .post("/api/deleteAddress", { id: id })
                .then(() => {
                    toast.fire({
                        icon: "success",
                        title: "Addresses Updated",
                    });
                    this.getAddresses();
                })
                .catch(() => {
                    toast.fire({
                        icon: "success",
                        title: "Failed",
                    });
                });
        },

        updateAddress() {
            this.aform.profile_id = this.form.id;
            this.aform
                .post("/api/addLeadAddress")
                .then((response) => {
                    if (response.data == 200) {
                        toast.fire({
                            icon: "success",
                            title: "Addresses Updated",
                        });
                        this.errors = [];
                        this.getAddresses();
                    }
                })
                .catch((errors) => {
                    toast.fire({
                        icon: "error",
                        title: "Failed",
                    });
                    this.errors = errors.response.data.errors;
                });
        },

        getAddresses() {
            axios
                .post("/api/getLeadAddresses", { id: this.form.id })
                .then((response) => {
                    this.addresses = response.data;
                });
        },

        onChange() {
            this.files = [...this.$refs.file.files];
        },
        dragover(e) {
            e.preventDefault();
            this.isDragging = true;
        },
        dragleave() {
            this.isDragging = false;
        },
        drop(e) {
            e.preventDefault();
            this.$refs.file.files = e.dataTransfer.files;
            this.onChange();
            this.isDragging = false;
        },
        remove(i) {
            this.files.splice(i, 1);
        },
        generateURL(file) {
            let fileSrc = URL.createObjectURL(file);
            setTimeout(() => {
                URL.revokeObjectURL(fileSrc);
            }, 1000);
            return fileSrc;
        },
        uploadProfileImage() {
            // const files = this.files;
            // const formData = new FormData();
            // files.forEach((file) => {
            //     formData.append("selectedFiles", file);
            // });
            const file = this.files[0];
            const formData = new FormData();
            formData.append("image", file);
            formData.append("lead_profile_id", this.lead_profile_id);
            formData.append("user_id", this.form.uid);
            console.log(file);
            axios({
                method: "POST",
                url: "/api/uploadUserProfileImage",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    // $("#addDCConfirmModal").modal("hide");
                    toast.fire({
                        icon: "success",
                        title: "Image added to verification queue",
                    });
                    this.llabel = "";
                    this.lshow = false;
                    // $("#DCGeneratedModal").modal("show");
                })
                .catch((errors) => {
                    this.lshow = false;
                    // $("#addDCConfirmModal").modal("hide");
                    toast.fire({
                        icon: "error",
                        title: "Upload Failed!",
                    });
                    this.lshow = false;
                    this.errors = errors.response.data.errors;
                });
            console.log(this.files[0]);
        },
    },
};
</script>
